import React from 'react';

import './CardItemList.scss';

import { ScrollToTop } from '../../ScrollToTop/ScrollToTop';

interface ICardItemListProps {
  items: JSX.Element[];
  singleItemName: string;
  isCurrentUser?: boolean;
};

export function CardItemList({ items, singleItemName, isCurrentUser }: ICardItemListProps) {
  const renderItem = (items: JSX.Element[]) =>
    items.map((Item: JSX.Element, i: number) => (
      <>
        { Item }
      </>
    ));

  return (
    <>
      <ul className='CardItemsList'>
        {
          items && items.length
            ? renderItem(items)
            : (
              <div className='CardItemsList__empty-hint'>
                <p>{ `No ${singleItemName}s yet here.` }</p>
                {
                  isCurrentUser
                  ? <p>But you can create some.</p>
                  : null
                }
              </div>
            )
        }
      </ul>
      <ScrollToTop />
    </>
  );
}
